module.exports = __webpack_public_path__ + "static/img/industry-jr.cd50f386.png";